import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Audesp4LicitanteCPF, RegistroPrecos } from 'eddydata-lib';
import { BaseLicitacaoAudesp } from '../../util/base-licitacao-audesp';
import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'lib-licitacao-audesp-licitante-cpf',
  templateUrl: './licitacao-audesp-licitante-cpf.component.html'
})
export class LicitacaoAudespLicitanteCPFComponent extends BaseLicitacaoAudesp implements OnChanges {

  @Input() public entidade: RegistroPrecos;

  public licitanteAtual: Audesp4LicitanteCPF;
  public licitanteAnterior: Audesp4LicitanteCPF;
  public listaLotes: { id: number, nome: string }[];

  constructor(
  ) {
    super()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['entidade']) {
      this.listaLotes = [];
      if (this.entidade.tipoObjeto === 'COMPRA_SERVICO' && this.entidade.ComprasServicos?.Lote) {
        this.entidade.ComprasServicos.Lote.forEach(lote => {
          this.listaLotes.push({ id: lote.NumeroLote, nome: lote.DescricaoLote })
        })
      } else if (this.entidade.tipoObjeto === 'COMPRA_SERVICO_TI' && this.entidade.ComprasServicosTI?.Lote) {
        this.entidade.ComprasServicosTI.Lote.forEach(lote => {
          this.listaLotes.push({ id: lote.NumeroLote, nome: lote.DescricaoLote })
        })
      } else if (this.entidade.tipoObjeto === 'ENGENHARIA' && this.entidade?.ObrasServicosEngenharia?.Lote) {
        this.entidade.ObrasServicosEngenharia.Lote.forEach(lote => {
          this.listaLotes.push({ id: lote.NumeroLote, nome: lote.DescricaoLote })
        })
      }
    }
  }

  public adicionar() {
    if (!this.entidade.Licitante.LicitanteCPF || this.entidade.Licitante.LicitanteCPF.length === 0) this.entidade.Licitante.LicitanteCPF = [];

    this.licitanteAtual = {
      CPF: undefined, LicitanteDeclaracaoMicroEmpresaPequenoPorte: 'N', Nome: undefined, LicitanteLoteItens: []
    }
    this.entidade.Licitante.LicitanteCPF.push(this.licitanteAtual);
    $('#dialogLicitanteCPF').modal('show');
  }

  public visualizar(item: Audesp4LicitanteCPF) {
    this.licitanteAnterior = Object.assign({}, item);
    this.licitanteAtual = item;
    this.licitanteAtual['edicao'] = true;
    $('#dialogLicitanteCPF').modal('show');
  }

  public cancelar() {
    if (this.licitanteAtual['edicao']) {
      if (this.licitanteAtual.LicitanteLoteItens.find(item => item.editavel)) {
        toastr.warning('Finalize a edição do item antes de concluir essa ação!')
        return;
      }
      let itm = this.entidade.Licitante.LicitanteCPF.find((item) => item === this.licitanteAtual);
      itm = Object.assign({}, this.licitanteAnterior);
      this.entidade.Licitante.LicitanteCPF.splice(this.entidade.Licitante.LicitanteCPF.indexOf(this.licitanteAtual), 1, itm)
    } else {
      this.remover(this.licitanteAtual);
    }
    this.licitanteAnterior = undefined;
    this.licitanteAtual = undefined;
    $('#dialogLicitanteCPF').modal('hide');
  }

  public remover(item: Audesp4LicitanteCPF) {
    this.licitanteAtual = undefined;
    this.entidade.Licitante.LicitanteCPF.splice(this.entidade.Licitante.LicitanteCPF.indexOf(item), 1)
  }

  public salvar() {
    if (this.licitanteAtual.LicitanteLoteItens.find(item => item.editavel)) {
      toastr.warning('Finalize a edição do item antes de concluir essa ação!')
      return;
    }
    if (!this.licitanteAtual?.IdentificacaoLicitante && this.entidade.modalidade === 4) {
      toastr.warning('Informe a identificação do participante antes de concluir essa ação!')
      return;
    }
    this.licitanteAtual = undefined;
    $('#dialogLicitanteCPF').modal('hide');
  }
}
